
// ═══ SHOPIFY CONFIG ═══
const CDN = 'https://cdn.shopify.com/s/files/1/1003/3987/6224/files/';
const SHOPIFY_DOMAIN = 's0ysw1-1n.myshopify.com';
const SHOPIFY_TOKEN = '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';

// ═══ VARIANT IDs (hardcoded from Shopify Admin) ═══
const VARIANT_IDS = {
  'bee-mug': {
    'Olive':    '58323059540352',
    'Castanho': '58323059507584',
    'Branco':   '58323059573120',
  },
  'bee-espresso': {
    'Olive':    '58323105055104',
    'Castanho': '58323105087872',
    'Branco':   '58323105120640',
  },
  'frontier-tray': {
    'default':  '58345862070656',
  }
};

async function shopifyFetchVariants(handle) {
  var ids = VARIANT_IDS[handle];
  if (!ids) return {};
  var map = {};
  Object.entries(ids).forEach(function([col, id]) {
    map[col] = { id: id, available: true, qty: 99 };
  });
  return map;
}

async function shopifyCheckout(items) {
  // Use Shopify cart API - no token needed
  try {
    var formData = [];
    items.forEach(function(item) {
      formData.push({ id: item.v, quantity: item.q });
    });
    
    // Add all items to cart
    for (var i = 0; i < formData.length; i++) {
      var res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: formData[i].id, quantity: formData[i].quantity })
      });
      var d = await res.json();
      if (d.status && d.status !== 200) {
        console.error('Cart add error:', d);
        alert('Error adding to cart: ' + (d.description || d.message || 'Please try again.'));
        return;
      }
    }
    // Redirect to checkout
    window.location.href = '/checkout';
  } catch(e) {
    console.error('Checkout error:', e);
    alert('Could not connect. Please try again.');
  }
}

const SHOPIFY_HANDLES = {mug30:'bee-mug',espresso:'bee-espresso',tray:'frontier-tray'};
const _sv = {};

// ═══ NAVIGATION (replaces SPA showPage/openProduct/openStory) ═══
function showPage(p){
  var m={home:'/',shop:'/collections/all',stories:'/blogs/journal',info:'/pages/studio',
    stockists:'/pages/where-to-buy',privacy:'/policies/privacy-policy',
    terms:'/policies/terms-of-service',refund:'/policies/refund-policy'};
  if(m[p]) window.location.href=m[p];
}
function openProduct(id,pack){
  var m={mug30:'/products/bee-mug',espresso:'/products/bee-espresso',tray:'/products/frontier-tray'};
  if(m[id]) window.location.href=m[id]+(pack?'?pack='+pack:'');
}
function openStory(id){
  var m={frontier:'/pages/journal-frontier',bee:'/pages/journal-bee-collection',
    campaign:'/pages/journal-the-film',identity:'/pages/journal-identity',
    akira:'/pages/journal-akira2000'};
  if(m[id]) window.location.href=m[id];
}
function histBack(){history.back();}
function closeStory(){window.location.href='/blogs/journal';}

// ═══ SHOPIFY STOREFRONT API ═══




function normCol(c){
  // Map from display names to Shopify variant names
  var m={
    'Olive':'Olive','olive':'Olive',
    'White':'Branco','white':'Branco','Branco':'Branco','branco':'Branco',
    'Brown':'Castanho','brown':'Castanho','Castanho':'Castanho','castanho':'Castanho'
  };
  return m[c]||c;
}

async function findVariant(variants, col) {
  var shopifyName = normCol(col);
  // Try exact match first, then lowercase
  var tries = [shopifyName, col, col.toLowerCase(), shopifyName.toLowerCase()];
  for(var t of tries) {
    if(variants[t]) return variants[t];
  }
  // Return first available
  return Object.values(variants)[0];
}

async function atcFromPD(){
  if(!curProd) return;
  var p=PRODS[curProd];
  var handle=SHOPIFY_HANDLES[curProd];
  if(!handle) return;
  var btn=document.querySelector('.atc-btn');
  if(btn){btn.textContent='Adding...';btn.disabled=true;}
  try{
    var pk=p.packs[selPack];
    // Build cart item
    var colorLabel='';
    var cartImg='';
    var shopifyItems=[];
    var variants=await shopifyFetchVariants(handle);
    
    if(!p.hasColor){
      var vdata=Object.values(variants)[0];
      colorLabel='';
      cartImg=p.photos[0]?p.photos[0].src:'';
      shopifyItems.push({v:vdata.id,q:pk.qty||1});
    } else if(pk.cups<=1){
      var vdata=await findVariant(variants,singleCol);
      if(!vdata.available){showNotif('This colour is out of stock');return;}
      colorLabel=singleCol;
      cartImg=p.colPhotos?p.colPhotos[singleCol]:'';
      shopifyItems.push({v:vdata.id,q:1});
    } else {
      var mugV=await shopifyFetchVariants('bee-mug');
      var espV=await shopifyFetchVariants('bee-espresso');
      var colMug={},colEsp={};
      pk.cupLabels.forEach(function(lbl,i){
        var col=cupCols['c'+i]||'Olive';
        if(lbl.includes('Espresso')) colEsp[col]=(colEsp[col]||0)+1;
        else colMug[col]=(colMug[col]||0)+1;
      });
      var colors=pk.cupLabels.map(function(_,i){return cupCols['c'+i]||'Olive';});
      colorLabel=colors.join(' + ');
      cartImg=p.packPhotos?p.packPhotos[pk.label]||'':'';
      for(var [col,qty] of Object.entries(colMug)){
        var vd=await findVariant(mugV,col);
        shopifyItems.push({v:vd.id,q:qty});
      }
      for(var [col,qty] of Object.entries(colEsp)){
        var vd=await findVariant(espV,col);
        shopifyItems.push({v:vd.id,q:qty});
      }
    }
    
    // Add to local cart
    var key=curProd+'-'+selPack+'-'+colorLabel+'-'+Date.now();
    cart.push({
      key:key,
      pid:curProd,
      name:pk.cups>1?pk.label:p.name,
      subName:p.subName,
      packName:pk.cups>1?pk.label:'',
      colorLabel:colorLabel,
      price:pk.price,
      qty:1,
      isPack:pk.cups>1,
      cartImg:cartImg,
      swColor:colorLabel?'var(--sw-'+colorLabel.toLowerCase()+')':'var(--off)',
      shopifyItems:shopifyItems
    });
    saveCart();
    updBag();
    showNotif('Added to cart');
    flyToCart();
    openCart();
    
  }catch(e){console.error(e);alert('Could not add to cart. Please try again.');}
  finally{if(btn){btn.textContent='Add to Cart';btn.disabled=false;}}
}

async function quickBuyShopify(prodId,ev){
  if(ev) ev.stopPropagation();
  var handle=SHOPIFY_HANDLES[prodId];
  var variants=await shopifyFetchVariants(handle);
  var vid=Object.values(variants)[0].id;
  await shopifyCheckout([{v:vid,q:1}]);
}

// ═══ STOCK CHECK — updates UI with real Shopify stock ═══
async function checkStock(){
  var handles=['bee-mug','bee-espresso','frontier-tray'];
  for(var h of handles){
    try{
      var variants=await shopifyFetchVariants(h);
      var prodId={'bee-mug':'mug30','bee-espresso':'espresso','frontier-tray':'tray'}[h];
      // Update swatch availability on product page
      Object.entries(variants).forEach(function([colKey,vdata]){
        var colName=Object.entries({olive:'Olive',branco:'White',castanho:'Brown'}).find(function([k]){return k===colKey;});
        if(colName){
          var sw=document.querySelector('.sw-'+colName[1].toLowerCase());
          if(sw){
            sw.classList.toggle('out-of-stock',!vdata.available);
            sw.title=colName[1]+(vdata.available?'':' — Out of stock');
            if(vdata.available&&vdata.qty<=3){
              sw.title=colName[1]+' — Last '+vdata.qty+' units';
            }
          }
        }
      });
    }catch(e){console.warn('Stock check failed:',e);}
  }
}



const SW={Olive:'var(--sw-olive)',White:'var(--sw-white)',Brown:'var(--sw-brown)'};

const PRODS={
  mug30:{
    id:'mug30',name:'Bee Mug',subName:'30cl',cat:'Bee Collection',basePrice:27,
    photos:[
      {type:'dynamic',src:'https://cdn.shopify.com/s/files/1/1003/3987/6224/files/bee-mug-olive.webp'},
      {type:'img',src:'https://cdn.shopify.com/s/files/1/1003/3987/6224/files/bee-mug-04.webp?v=1791897752'},
      {type:'img',src:'https://cdn.shopify.com/s/files/1/1003/3987/6224/files/1.png?v=1791900574'},
      {type:'img',src:'https://cdn.shopify.com/s/files/1/1003/3987/6224/files/WhatsApp_Image_2026-10-13_at_14.59.25.jpg?v=1791900098'},
      {type:'img',src:'https://cdn.shopify.com/s/files/1/1003/3987/6224/files/bee-mug-08.webp'},
      {type:'img',src:'https://cdn.shopify.com/s/files/1/1003/3987/6224/files/BEE_em_uso.jpg?v=1791902383'},
    ],
    hasColor:true,
    packs:[
      {label:'1 Bee Mug',price:27,qty:1,cups:1,cupLabels:['Bee Mug']},
      {label:'1 Bee Mug + 1 Bee Espresso',price:39,qty:2,cups:2,save:7,cupLabels:['Bee Mug','Bee Espresso']},
      {label:'2 Bee Mugs',price:43,qty:2,cups:2,save:11,cupLabels:['Bee Mug','Bee Mug']},
      {label:'2 Bee Mugs + 2 Bee Espressos',price:72,qty:4,cups:4,save:20,cupLabels:['Bee Mug','Bee Mug','Bee Espresso','Bee Espresso']},
    ],
    details:'Defined by a series of horizontal ribs, the Bee Collection is designed to stack intuitively while providing a comfortable grip. A familiar cylindrical form refined through careful attention to proportion, function and everyday use.\nAvailable in Olive, White, and Brown and in two sizes. Each piece is individually made. Slight variations are the mark of craft.',
    care:'Hand wash recommended to preserve the glaze. Dishwasher safe on gentle cycles. Do not microwave.',
    designer:'Francisco Pereira',year:'2026',
    phDefault:'var(--c-mug-d)',phHover:'var(--c-mug-s)',
    shopImg:'https://cdn.shopify.com/s/files/1/1003/3987/6224/files/bee-mug-01.webp',shopImgHover:'https://cdn.shopify.com/s/files/1/1003/3987/6224/files/bee-mug-02.webp',
    colGradients:{
      Olive:'linear-gradient(160deg,#a8a878 0%,#6a6a44 100%)',
      White:'linear-gradient(160deg,#f0ede6 0%,#d8d4c8 100%)',
      Brown:'linear-gradient(160deg,#b08060 0%,#7a5438 100%)',
    },
    colPhotos:{Olive:'https://cdn.shopify.com/s/files/1/1003/3987/6224/files/bee-mug-olive.webp',White:'https://cdn.shopify.com/s/files/1/1003/3987/6224/files/bee-mug-white.webp',Brown:'https://cdn.shopify.com/s/files/1/1003/3987/6224/files/bee-mug-brown.webp'},
    packPhotos:{'1 Bee Mug':'https://cdn.shopify.com/s/files/1/1003/3987/6224/files/bee-mug-olive.webp','2 Bee Mugs':'https://cdn.shopify.com/s/files/1/1003/3987/6224/files/bee-duo-mug-01.webp','1 Bee Mug + 1 Bee Espresso':'https://cdn.shopify.com/s/files/1/1003/3987/6224/files/bee-morningset-01.webp','2 Bee Mugs + 2 Bee Espressos':'https://cdn.shopify.com/s/files/1/1003/3987/6224/files/bee-fullcollection-01.webp'},
    packGradient:'linear-gradient(160deg,#c0b490 0%,#8a7860 100%)',
    upsell:'Complete the morning ritual. The Morning Set (1 Bee Mug + 1 Bee Espresso) is our most popular combination at €39.',upsellId:'espresso',upsellPack:2,
    learnMore:{story:'bee',img:'https://cdn.shopify.com/s/files/1/1003/3987/6224/files/story-bee-01-new.webp',title:'Learn more about the design process of the Bee Collection',text:'The Bee Collection began with a simple objective: to create a mug that was comfortable to use and easy to store. From the start, stacking became an important part of the design.'},
    info:'<strong>Material</strong><br>Porcelain, glazed finish<br><br><strong>Capacity</strong><br>30cl<br><br><strong>Dimensions</strong><br>Ø 78 × H 85 mm<br><br><strong>Weight</strong><br>190 g<br><br><strong>Care</strong><br>Hand wash recommended to preserve the glaze. Dishwasher safe on gentle cycles.<br><br><strong>Shipping</strong><br>Free on orders over €75. Delivered within 5–8 business days from Europe.',
  },
  espresso:{
    id:'espresso',name:'Bee Espresso',subName:'Espresso Cup',cat:'Bee Collection',basePrice:19,
    photos:[
      {type:'dynamic',src:'https://cdn.shopify.com/s/files/1/1003/3987/6224/files/bee-espresso-olive.webp'},
      {type:'img',src:'https://cdn.shopify.com/s/files/1/1003/3987/6224/files/bee_espresso_na_mao.jpg?v=1791903568'},
      {type:'img',src:'https://cdn.shopify.com/s/files/1/1003/3987/6224/files/Bee_espresso_all_colors_in_a_row.jpg?v=1792078967'},
      {type:'img',src:'https://cdn.shopify.com/s/files/1/1003/3987/6224/files/bee-espresso-04.webp'},
      {type:'img',src:'https://cdn.shopify.com/s/files/1/1003/3987/6224/files/bee_espresso_31.jpg?v=1791902905'},
      {type:'img',src:'https://cdn.shopify.com/s/files/1/1003/3987/6224/files/bee_mug_and_bee_espresso.jpg?v=1792084066'},
    ],
    hasColor:true,
    packs:[
      {label:'1 Bee Espresso',price:19,qty:1,cups:1,cupLabels:['Bee Espresso']},
      {label:'2 Bee Espressos',price:31,qty:2,cups:2,save:7,cupLabels:['Bee Espresso','Bee Espresso']},
      {label:'1 Bee Mug + 1 Bee Espresso',price:39,qty:2,cups:2,save:7,cupLabels:['Bee Mug','Bee Espresso']},
      {label:'4 Bee Espressos',price:54,qty:4,cups:4,save:22,cupLabels:['Bee Espresso','Bee Espresso','Bee Espresso','Bee Espresso']},
      {label:'2 Bee Mugs + 2 Bee Espressos',price:72,qty:4,cups:4,save:20,cupLabels:['Bee Mug','Bee Mug','Bee Espresso','Bee Espresso']},
    ],
    details:'Defined by a series of horizontal ribs, the Bee Collection is designed to stack intuitively while providing a comfortable grip. A familiar cylindrical form refined through careful attention to proportion, function and everyday use.\nAvailable in Olive, White, and Brown and in two sizes. Each piece is individually made. Slight variations are the mark of craft.',
    care:'Hand wash recommended to preserve the glaze. Dishwasher safe on gentle cycles. Do not microwave.',
    designer:'Francisco Pereira',year:'2026',
    phDefault:'var(--c-esp-d)',phHover:'var(--c-esp-s)',
    shopImg:'https://cdn.shopify.com/s/files/1/1003/3987/6224/files/bee-espresso-01.webp',shopImgHover:'https://cdn.shopify.com/s/files/1/1003/3987/6224/files/bee-espresso-02.webp',
    colGradients:{
      Olive:'linear-gradient(160deg,#9a9a70 0%,#626248 100%)',
      White:'linear-gradient(160deg,#e8e4dc 0%,#ccc8bc 100%)',
      Brown:'linear-gradient(160deg,#a87858 0%,#724c34 100%)',
    },
    colPhotos:{Olive:'https://cdn.shopify.com/s/files/1/1003/3987/6224/files/bee-espresso-olive.webp',White:'https://cdn.shopify.com/s/files/1/1003/3987/6224/files/bee-espresso-white.webp',Brown:'https://cdn.shopify.com/s/files/1/1003/3987/6224/files/bee-espresso-brown.webp'},
    packPhotos:{'1 Bee Espresso':'https://cdn.shopify.com/s/files/1/1003/3987/6224/files/bee-espresso-olive.webp','2 Bee Espressos':'https://cdn.shopify.com/s/files/1/1003/3987/6224/files/bee-duo-espresso-01.webp','1 Bee Mug + 1 Bee Espresso':'https://cdn.shopify.com/s/files/1/1003/3987/6224/files/bee-morningset-01.webp','4 Bee Espressos':'https://cdn.shopify.com/s/files/1/1003/3987/6224/files/bee-studioset-01.webp','2 Bee Mugs + 2 Bee Espressos':'https://cdn.shopify.com/s/files/1/1003/3987/6224/files/bee-fullcollection-01.webp'},
    packGradient:'linear-gradient(160deg,#b0a480 0%,#807060 100%)',
    upsell:'Add a Bee Mug for the full morning ritual. The Morning Set (1 Bee Mug + 1 Bee Espresso) at €39 saves you €7.',upsellId:'mug30',upsellPack:1,
    learnMore:{story:'bee',img:'https://cdn.shopify.com/s/files/1/1003/3987/6224/files/story-bee-01-new.webp',title:'Learn more about the design process of the Bee Collection',text:'The Bee Collection began with a simple objective: to create a mug that was comfortable to use and easy to store. From the start, stacking became an important part of the design.'},
    info:'<strong>Material</strong><br>Porcelain, glazed finish<br><br><strong>Capacity</strong><br>7cl<br><br><strong>Dimensions</strong><br>Ø 52 × H 60 mm<br><br><strong>Weight</strong><br>110 g<br><br><strong>Care</strong><br>Hand wash recommended to preserve the glaze. Dishwasher safe on gentle cycles.<br><br><strong>Shipping</strong><br>Free on orders over €75. Delivered within 5–8 business days from Europe.',
  },
  tray:{
    id:'tray',name:'Frontier',subName:'Domestic Tray',cat:'Tray',basePrice:65,
    photos:[
      {type:'img',src:'https://cdn.shopify.com/s/files/1/1003/3987/6224/files/frontier-01.webp',cls:'ph-tall'},
      {type:'img',src:'https://cdn.shopify.com/s/files/1/1003/3987/6224/files/hero-frontier.webp?v=1782596633',cls:'ph-tall'},
      {type:'img',src:'https://cdn.shopify.com/s/files/1/1003/3987/6224/files/frontier-05.webp?v=1782668010',cls:'ph-tall'},
      {type:'img',src:'https://cdn.shopify.com/s/files/1/1003/3987/6224/files/frontier-02.webp?v=1782316786',cls:'ph-tall'},
      {type:'img',src:'https://cdn.shopify.com/s/files/1/1003/3987/6224/files/frontier-04.webp?v=1782316757',cls:'ph-tall'},
      {type:'img',src:'https://cdn.shopify.com/s/files/1/1003/3987/6224/files/frontier-06-new.webp',cls:'ph-tall'},
    ],
    hasColor:false,
    packs:[{label:'Single piece',price:65,qty:1,cups:0}],
    details:'Frontier is a tray crafted from American oak with an aluminium back. Rather than a traditional bent metal sheet, the design uses an angle bracket, simplifying the structure and eliminating the visual marks of that process. The wooden body is angled at the top, allowing items to slide easily into place against the metal wall. A minimal object with an industrial logic, designed for home or studio use.',
    care:'Clean with a dry or slightly damp cloth. Do not soak in water. Apply natural wood oil occasionally to maintain the oak finish.',
    designer:'Francisco Pereira',year:'2025',
    phDefault:'var(--c-tray-d)',phHover:'var(--c-tray-s)',
    upsell:null,
    learnMore:{story:'frontier',img:'https://cdn.shopify.com/s/files/1/1003/3987/6224/files/story-frontier-01-new.webp',title:'Learn more about the design process of Frontier',text:'The journey of designing the Frontier tray began in Copenhagen and concluded in Portugal. Conceived in early 2024, the idea emerged from observing how people quickly empty their pockets upon arriving home.'},
    info:'<strong>Material</strong><br>American oak, dull aluminum<br><br><strong>Dimensions</strong><br>W 220 × D 120 × H 30 mm<br><br><strong>Weight</strong><br>520 g<br><br><strong>Care</strong><br>Clean with a dry or slightly damp cloth. Do not soak in water. Apply natural wood oil occasionally to maintain the oak finish.<br><br><strong>Shipping</strong><br>Free on orders over €75. Delivered within 5–8 business days from Europe.',
  },
};

const PACKS_DATA=[
  {name:'Duo Espresso',sub:'2 × Bee Espresso',price:'€31',save:'Save €7',color:'var(--c-esp-d)',id:'espresso',pIdx:1,img:'https://cdn.shopify.com/s/files/1/1003/3987/6224/files/bee-duo-espresso-01.webp'},
  {name:'Morning Set',sub:'1 Bee Mug + 1 Bee Espresso',price:'€39',save:'Save €7',color:'var(--c-mug-s)',id:'espresso',pIdx:2,popular:true,img:'https://cdn.shopify.com/s/files/1/1003/3987/6224/files/bee-morningset-01.webp'},
  {name:'Duo Mug',sub:'2 × Bee Mug',price:'€43',save:'Save €11',color:'var(--c-mug-d)',id:'mug30',pIdx:1,img:'https://cdn.shopify.com/s/files/1/1003/3987/6224/files/bee-duo-mug-01.webp'},
  {name:'Full Collection',sub:'2 Bee Mug + 2 Bee Espresso',price:'€72',save:'Save €20',color:'var(--c-mug-s)',id:'mug30',pIdx:3,img:'https://cdn.shopify.com/s/files/1/1003/3987/6224/files/bee-fullcollection-01.webp'},
  {name:'Studio Set',sub:'4 × Bee Espresso',price:'€54',save:'Save €22',color:'var(--c-esp-s)',id:'espresso',pIdx:3,img:'https://cdn.shopify.com/s/files/1/1003/3987/6224/files/bee-studioset-01.webp'},
];

let cart=JSON.parse(localStorage.getItem('seis_cart')||'[]'),curProd=null,selPack=0,singleCol='Olive',cupCols={},prevPage='home';

function saveCart(){localStorage.setItem('seis_cart',JSON.stringify(cart));}

// CART
function cartTotal(){return cart.reduce((s,i)=>s+i.price*i.qty,0)}
function cartCount(){return cart.reduce((s,i)=>s+i.qty,0)}
function flyToCart(srcEl){
  // Create flying dot from click position or cursor position
  var dot=document.createElement('div');
  dot.className='cart-fly-dot';
  document.body.appendChild(dot);
  // Start position: current cursor or center of viewport
  var startX=window._lastClickX||window.innerWidth/2;
  var startY=window._lastClickY||window.innerHeight/2;
  // End position: navBag element
  var bag=document.getElementById('navBag');
  var bagRect=bag?bag.getBoundingClientRect():{left:window.innerWidth-40,top:20};
  var endX=bagRect.left+bagRect.width/2;
  var endY=bagRect.top+bagRect.height/2;
  dot.style.cssText='position:fixed;left:'+startX+'px;top:'+startY+'px;width:18px;height:18px;border-radius:50%;background:var(--black);transform:translate(-50%,-50%) scale(1.8);z-index:9999;pointer-events:none;transition:left .5s cubic-bezier(.25,.46,.45,.94),top .5s cubic-bezier(.25,.46,.45,.94),transform .5s ease,opacity .5s ease';
  requestAnimationFrame(function(){
    requestAnimationFrame(function(){
      dot.style.left=endX+'px';
      dot.style.top=endY+'px';
      dot.style.transform='translate(-50%,-50%) scale(0.3)';
      dot.style.opacity='0';
    });
  });
  setTimeout(function(){
    if(dot.parentNode)dot.parentNode.removeChild(dot);
    animateBag();
  },520);
}
// Track cursor position
document.addEventListener('mousemove',function(e){window._lastClickX=e.clientX;window._lastClickY=e.clientY;});
document.addEventListener('click',function(e){window._lastClickX=e.clientX;window._lastClickY=e.clientY;});

function animateBag(){
  var bag=document.getElementById('navBag');
  if(!bag)return;
  bag.classList.remove('bag-pop');
  void bag.offsetWidth;
  bag.classList.add('bag-pop');
  setTimeout(function(){bag.classList.remove('bag-pop');},500);
}
function updBag(){document.getElementById('navBag').textContent=cartCount()}

function addToCart(pid,colorInfo,packIdx){
  const p=PRODS[pid],pk=p.packs[packIdx??0];
  const key=pid+'-'+JSON.stringify(colorInfo)+'-'+(packIdx??0);
  const ex=cart.find(i=>i.key===key);
  const colorLabel=Array.isArray(colorInfo)?colorInfo.join(' + '):(colorInfo||'');
  const swColor=Array.isArray(colorInfo)?SW[colorInfo[0]]:SW[colorInfo]||'var(--off)';
  const isPack=pk.cups>1;
  // Image: pack image if pack, colour image if single
  var cartImg='';
  if(isPack){
    cartImg=pk.packImg||(p.packPhotos?p.packPhotos[pk.label]:'');
  } else {
    const col=Array.isArray(colorInfo)?colorInfo[0]:colorInfo;
    cartImg=p.colPhotos?p.colPhotos[col]||p.photos[0]?.src||'':p.photos[0]?.src||'';
  }
  // Cup details for packs
  var cups=[];
  if(isPack&&pk.cupLabels&&Array.isArray(colorInfo)){
    pk.cupLabels.forEach(function(label,i){
      cups.push({obj:label,color:colorInfo[i]||colorInfo[0]});
    });
  }
  if(ex){ex.qty++}
  else{cart.push({key,pid,name:p.name,subName:pk.label,packName:isPack?pk.label:'',
    colorLabel,price:pk.price,qty:1,swColor,cartImg,cups,isPack})}
  saveCart();updBag();flyToCart();showNotif('Added to cart');
}



// Colour name normalisation for Shopify variant lookup




function removeFromCart(key){
  cart=cart.filter(i=>i.key!==key);
  updBag();renderCart();
}

function chQtyEl(btn,d){
  var idx=parseInt(btn.closest('[data-idx]').getAttribute('data-idx'));
  if(cart[idx]){cart[idx].qty+=d;if(cart[idx].qty<=0)cart.splice(idx,1);saveCart();updBag();renderCart();}
}
function removeFromCartEl(btn){
  var idx=parseInt(btn.getAttribute('data-idx'));
  if(!isNaN(idx)){cart.splice(idx,1);saveCart();updBag();renderCart();}
}
function chQty(key,d){
  const it=cart.find(i=>i.key===key);
  if(!it)return;
  it.qty+=d;
  if(it.qty<=0){cart=cart.filter(i=>i.key!==key)}
  updBag();renderCart();
}

function renderCart(){
  const el=document.getElementById('cartItems'),ft=document.getElementById('cartFt');
  if(!el||!ft) return;
  if(!cart.length){el.innerHTML='<div class="cart-empty">Your cart is empty.</div>';ft.innerHTML='';return}
  el.innerHTML=cart.map(function(it,ci_idx){
    var imgHtml=it.cartImg
      ? '<img src="'+it.cartImg+'" alt="" style="width:100%;height:100%;object-fit:cover">'
      : '<div style="width:100%;height:100%;background:'+it.swColor+'"></div>';
    var cupsHtml='';
    if(it.isPack&&it.cups&&it.cups.length){
      cupsHtml='<div class="ci-cups">'
        +it.cups.map(function(c){return '<span class="ci-cup">'+c.obj+' · '+c.color+'</span>';}).join('')
        +'</div>';
    }
    return '<div class="ci">'
      +'<div class="ci-img">'+imgHtml+'</div>'
      +'<div class="ci-mid">'
      +'<div class="ci-name">'+(it.isPack?it.packName:it.name)+'</div>'
      +(it.isPack?cupsHtml:'<div class="ci-var">'+it.colorLabel+'</div>')
      +'<div class="ci-qty" data-idx="'+ci_idx+'">'
      +'<button onclick="chQtyEl(this,-1)">−</button>'
      +'<span>'+it.qty+'</span>'
      +'<button onclick="chQtyEl(this,1)">+</button>'
      +'</div>'
      +'</div>'
      +'<div class="ci-right">'
      +'<div class="ci-price">€'+(it.price*it.qty).toFixed(0)+'</div>'
      +'<button class="ci-remove" data-idx="'+ci_idx+'" onclick="removeFromCartEl(this)" title="Remove">×</button>'
      +'</div>'
      +'</div>';
  }).join('');
  const tot=cartTotal(),rem=Math.max(0,75-tot),pct=Math.min(100,(tot/75)*100);
  ft.innerHTML=`
    <div class="sh-bar">
      <div class="sh-txt">${rem>0?`Add <strong>€${rem.toFixed(0)}</strong> for free shipping`:'<span style="color:#5a8a5a">Free shipping unlocked</span>'}</div>
      <div class="sh-prog"><div class="sh-fill" style="width:${pct}%"></div></div>
    </div>
    <div class="cart-tot"><span>Total</span><span>€${tot.toFixed(0)}</span></div>
    <button class="ck-btn" onclick="proceedToCheckout()">Proceed to Checkout</button>`;
}

async function proceedToCheckout(){
  if(!cart.length) return;
  var btn=document.querySelector('.ck-btn');
  if(btn){btn.textContent='Loading...';btn.disabled=true;}
  try{
    // Build checkout URL with variant IDs
    var parts=[];
    cart.forEach(function(item){
      if(item.shopifyItems){
        item.shopifyItems.forEach(function(si){
          parts.push(si.v+':'+si.q*item.qty);
        });
      }
    });

    // Determine discount code based on cart contents
    var discountCode = getDiscountCode();

    if(parts.length){
      cart=[];saveCart();
      var url='/cart/'+parts.join(',');
      if(discountCode) url+='?discount='+discountCode;
      window.location.href=url;
    }
  }catch(e){
    console.error(e);
    alert('Could not connect to checkout. Please try again.');
    if(btn){btn.textContent='Proceed to Checkout';btn.disabled=false;}
  }
}

function getDiscountCode(){
  // Count items by product
  var mugQty=0, espQty=0, trayQty=0;
  cart.forEach(function(item){
    if(item.shopifyItems){
      item.shopifyItems.forEach(function(si){
        // Identify by variant ID
        var mugIds=['58323059507584','58323059540352','58323059573120'];
        var espIds=['58323105055104','58323105087872','58323105120640'];
        if(mugIds.includes(si.v)) mugQty+=si.q*item.qty;
        if(espIds.includes(si.v)) espQty+=si.q*item.qty;
        if(si.v==='58345862070656') trayQty+=si.q*item.qty;
      });
    }
  });

  // Match pack combinations
  if(mugQty>=2 && espQty>=2) return 'FULLCOLLECTION';
  if(mugQty>=1 && espQty>=1) return 'MORNINGSET';
  if(espQty>=4) return 'PACK4ESP';
  if(espQty>=2) return 'PACK2ESP';
  if(mugQty>=2) return 'PACK2MUG';
  return null;
}

function openCart(){
  renderCart();
  var ov=document.getElementById('cartOv');
  var dr=document.getElementById('cartDr');
  if(ov) ov.classList.add('open');
  if(dr) dr.classList.add('open');
}
function closeCart(){document.getElementById('cartOv').classList.remove('open');document.getElementById('cartDr').classList.remove('open')}

// NAVIGATION



function renderPackOpts(p){
  document.getElementById('pdPackOpts').innerHTML=p.packs.map((pk,i)=>{
    const pop=pk.label.toLowerCase().includes('mug')&&pk.label.toLowerCase().includes('espresso');
    return`<div class="pack-opt ${i===selPack?'on':''}" onclick="selPack_(${i},this,'${p.id}')">
      <div class="pack-opt-hd">
        <span>${pk.label}${pop?`<span class="pop-badge">Popular</span>`:''}</span>
        <span>€${pk.price}${pk.save?`<span class="ps"> Save €${pk.save}</span>`:''}</span>
      </div>
      ${pk.cups>1?mkCupSels(pk.cups,pk.cupLabels):''}
    </div>`;
  }).join('');
  for(let i=0;i<20;i++)if(!cupCols['c'+i])cupCols['c'+i]='Olive';
}

function mkCupSels(n,cupLabels){
  const labels=cupLabels||Array.from({length:n},(_,i)=>'Cup '+(i+1));
  return`<div class="cup-colors-wrap">${Array.from({length:n},(_,ci)=>`
    <div class="cup-sel">
      <div class="cup-lbl">${labels[ci]||'Cup '+(ci+1)}</div>
      <div class="cup-sws">
        <div class="cup-sw cup-sw-olive ${(cupCols['c'+ci]||'Olive')==='Olive'?'on':''}" title="Olive" onclick="pickCupCol(${ci},'Olive',this,event)"></div>
        <div class="cup-sw cup-sw-white ${cupCols['c'+ci]==='White'?'on':''}" title="White" onclick="pickCupCol(${ci},'White',this,event)"></div>
        <div class="cup-sw cup-sw-brown ${cupCols['c'+ci]==='Brown'?'on':''}" title="Brown" onclick="pickCupCol(${ci},'Brown',this,event)"></div>
      </div>
    </div>`).join('')}</div>`;
}

function selPack_(i,el,pid){
  selPack=i;
  const p=PRODS[pid],pk=p.packs[i];
  document.querySelectorAll('.pack-opt').forEach(b=>b.classList.remove('on'));
  el.classList.add('on');
  document.getElementById('pdSingleCol').style.display=(p.hasColor&&pk.cups===1)?'':'none';
  updatePdPrice();
  // Update product name to reflect selected pack
  if(pk.cups>1){
    document.getElementById('pdName').textContent=pk.label;
  } else {
    document.getElementById('pdName').textContent=p.name;
  }
  const uh=document.getElementById('upsell');
  if(p.upsell&&i===0){uh.style.display='block';uh.innerHTML=`${p.upsell} <a onclick="openProduct('${p.upsellId}',${p.upsellPack})">See the set</a>`}
  else{uh.style.display='none'}
  highlightColorPh(singleCol);
 
  // Update first gallery image when selecting a pack
  var pp = PRODS[pid];
  var firstPhoto = document.querySelector('#pdPhotos .pd-gallery-img img');

  if (pp && firstPhoto) {
    var imageSrc = '';

    if (pk.cups > 1 && pp.packPhotos) {
      imageSrc = pp.packPhotos[pk.label] || '';
    }

    if (!imageSrc && pp.colPhotos) {
      imageSrc = pp.colPhotos[singleCol] || pp.colPhotos['Olive'] || '';
    }

    if (!imageSrc && pp.photos && pp.photos[0]) {
      imageSrc = pp.photos[0].src || '';
    }

    if (imageSrc) {
      firstPhoto.src = imageSrc;
    }
  }

}

function updateHeroPhoto(color,isPack){
  // no-op in new scroll layout
}

function pickSingleCol(name,el){
  singleCol=name;
  document.querySelectorAll('#pdSingleCol .sw').forEach(s=>s.classList.remove('on'));
  el.classList.add('on');
  document.getElementById('pdColLbl').textContent=name;
  updateHeroPhoto(name,false);
  highlightColorPh(name);
  // Update dynamic first gallery image by colour
  var p=PRODS[curProd];
  if(p&&p.colPhotos&&p.colPhotos[name]){
    var src=p.colPhotos[name];
    var dynImg=document.getElementById('pdDynImg');
    if(dynImg){
      var mi=dynImg.querySelector('img');if(mi)mi.src=src;
      
    }
  }
}

function pickCupCol(ci,color,el,ev){
  ev.stopPropagation();
  cupCols['c'+ci]=color;
  el.closest('.cup-sws').querySelectorAll('.cup-sw').forEach(s=>s.classList.remove('on'));
  el.classList.add('on');
  highlightColorPh(color);
}

function highlightColorPh(color){
  document.querySelectorAll('.pd-col-ph').forEach(ph=>{
    ph.style.outline=ph.getAttribute('data-color')===color?'3px solid var(--black)':'none';
  });
}

function updatePdPrice(){
  if(!curProd)return;
  const p=PRODS[curProd],pk=p.packs[selPack];
  document.getElementById('pdPrice').innerHTML='<span class="price-euro">€</span>'+pk.price;
  document.getElementById('pdShipLn').textContent=pk.price>=75?'Free shipping on this order':'';
}

// LIGHTBOX
var pdThumbIdx=0;
function pdNav(dir,ev){
  if(ev)ev.stopPropagation();
  var p=PRODS[curProd];if(!p)return;
  var n=p.photos.length;
  var next=(pdThumbIdx+dir+n)%n;
  var thumbs=document.querySelectorAll('.pd-thumb');
  if(thumbs[next])pdSelectThumb(next,thumbs[next]);
}
function pdCurrentSrc(){
  var p=PRODS[curProd];if(!p)return '';
  var ph=p.photos[pdThumbIdx];
  return ph&&ph.src?ph.src:'';
}
function pdSelectThumb(idx,el){
  pdThumbIdx=idx;
  var p=PRODS[curProd];if(!p)return;
  var ph=p.photos[idx];
  var mainImg=document.getElementById('pdMainImgEl');
  var heroBg=document.getElementById('pdHeroBg');
  if(ph.type==='dynamic'){
    // Dynamic: always show current colour photo
    var src=p.colPhotos?p.colPhotos[singleCol]||ph.src:ph.src;
    if(mainImg){mainImg.src=src;mainImg.style.display='';}
    if(heroBg)heroBg.style.display='none';
    var lbl=document.getElementById('pdMainLabel');
    if(lbl)lbl.textContent=src;
  } else if(ph.type==='img'){
    if(mainImg){mainImg.src=ph.src;mainImg.style.display='';}
    if(heroBg)heroBg.style.display='none';
    var lbl=document.getElementById('pdMainLabel');
    if(lbl)lbl.textContent=ph.src;
  } else {
    var colSrc=p.colPhotos?p.colPhotos[ph.color]:'';
    var bg=p.colGradients?p.colGradients[ph.color]||SW[ph.color]||'var(--off)':SW[ph.color]||'var(--off)';
    if(heroBg){heroBg.style.background=bg;heroBg.style.display='';}
    if(mainImg){
      if(colSrc){mainImg.src=colSrc;mainImg.style.display='';}
      else{mainImg.style.display='none';}
    }
    var lbl=document.getElementById('pdMainLabel');
    if(lbl)lbl.textContent=colSrc||ph.color||'';
  }
  document.querySelectorAll('.pd-thumb').forEach(function(t){t.classList.remove('active');});
  el.classList.add('active');
}
function openLB(src){document.getElementById('lbImg').src=src;document.getElementById('lb').classList.add('open')}
function closeLB(){document.getElementById('lb').classList.remove('open')}
document.addEventListener('keydown',e=>{if(e.key==='Escape')closeLB()});

// SHOP
function renderShop(filter){
  var g=document.getElementById('shopGrid');
  var ids=Object.keys(PRODS).filter(function(id){
    if(filter==='all') return true;
    if(filter==='mugs') return PRODS[id].id==='mug30'||PRODS[id].id==='espresso';
    if(filter==='accessories') return PRODS[id].id==='tray';
    return false;
  });
  g.innerHTML=ids.map(function(id){
    var p=PRODS[id];
    var isImg=p.photos[0].type==='img';
    var imgHtml;
    if(isImg){
      var s2=p.photos[1]?p.photos[1].src:'';
      imgHtml='<div class="ph-d" style="background:'+p.phDefault+'">'
             +'<img src="'+p.photos[0].src+'" alt="'+p.name+'" style="position:absolute;inset:0;width:100%;height:100%;object-fit:cover">'
             +'</div>'
             +'<div class="ph-s" style="background:'+p.phHover+'">'
             +'<img src="'+s2+'" alt="'+p.name+'" style="position:absolute;inset:0;width:100%;height:100%;object-fit:cover">'
             +'</div>';
    } else {
      var d=p.shopImg||'';
      var s=p.shopImgHover||'';
      imgHtml='<div class="ph-d" style="background:'+p.phDefault+'">'
             +(d?'<img src="'+d+'" alt="'+p.name+'" style="position:absolute;inset:0;width:100%;height:100%;object-fit:cover">':'')
             +'</div>'
             +'<div class="ph-s" style="background:'+p.phHover+'">'
             +(s?'<img src="'+s+'" alt="'+p.name+'" style="position:absolute;inset:0;width:100%;height:100%;object-fit:cover">':'')
             +'</div>';
    }
    var tag=p.cat==='tray'?'Tray':'Porcelain'+(p.id!=='tray'?' · New':'');
    var from=p.packs.length>1?'From ':'';
    return '<div class="prod-card" data-id="'+id+'" onclick="openProduct(this.dataset.id)">'
      +'<div class="prod-card-img">'+imgHtml+'</div>'
      +'<div class="prod-body">'
      +'<div class="prod-tag">'+tag+'</div>'
      +'<div class="prod-name">'+p.name+'</div>'
      +'<div class="prod-sub">'+p.subName+'</div>'
      +'<div class="prod-price">'+from+'€'+p.basePrice+'</div>'
      +'<div class="prod-stock">In stock · Delivery 5–8 business days</div>'
      +'</div></div>';
  }).join('');
}

function filterShop(f,el){
  document.querySelectorAll('.shop-filters li').forEach(l=>l.classList.remove('on'));
  el.classList.add('on');renderShop(f);
}

// CAROUSEL
function buildCar(){
  var tiles=[].concat(PACKS_DATA).concat(PACKS_DATA);
  document.getElementById('carTrack').innerHTML=tiles.map(function(p){
    var imgHtml=p.img
      ? '<img src="'+p.img+'" alt="" style="position:absolute;inset:0;width:100%;height:100%;object-fit:cover">'
      : '';
    var popular=p.popular?'<span class="pop-badge">Popular</span>':'';
    var tag=p.popular?' · Most popular':'';
    return '<div class="pack-tile" data-pid="'+p.id+'" data-pidx="'+p.pIdx+'" onclick="openProduct(this.dataset.pid, this.dataset.pidx)">'
      +'<div class="pack-tile-img" style="position:relative">'
      +''
      +imgHtml
      +'</div>'
      +'<div class="pack-tile-body">'
      +'<div class="pt-tag">Set'+tag+'</div>'
      +'<div class="pt-name">'+p.name+popular+'</div>'
      +'<div class="pt-price">'+p.price+'<span class="pt-save">'+p.save+'</span></div>'
      +'<div style="font-family:var(--mono);font-size:9px;color:var(--grey);margin-top:3px;letter-spacing:.07em">'+p.sub+'</div>'
      +'</div></div>';
  }).join('');
}


// STORIES

// NEWSLETTER
function subNL(){
  const v=document.getElementById('nlEmail').value;
  if(!v||!v.includes('@')){showNotif('Please enter a valid email');return}
  showNotif('Subscribed. Welcome to the process.');
  document.getElementById('nlEmail').value='';
}

// PARTNER FORM
function submitPartner(){
  const name=document.getElementById('pf-name').value;
  const email=document.getElementById('pf-email').value;
  const type=document.getElementById('pf-type').value;
  if(!name||!email||!type){showNotif('Please fill in all required fields');return}
  showNotif('Message sent. We will be in touch.');
  ['pf-name','pf-email','pf-company','pf-msg'].forEach(id=>document.getElementById(id).value='');
  document.getElementById('pf-type').value='';
}

// ACCORDION
function toggleAcc(btn){
  const b=btn.nextElementSibling,o=b.classList.contains('open');
  btn.classList.toggle('open',!o);b.classList.toggle('open',!o);
}

// NOTIF
let _nt;
function showNotif(m){const el=document.getElementById('notif');el.textContent=m;el.classList.add('show');clearTimeout(_nt);_nt=setTimeout(()=>el.classList.remove('show'),2600)}

// NAV
window.addEventListener('scroll',()=>document.getElementById('nav').classList.toggle('sc',scrollY>36));

// MOBILE
function openMob(){document.getElementById('mobNav').classList.add('open')}
function closeMob(){document.getElementById('mobNav').classList.remove('open')}

// DARK ZONES
function tagDark(){
  document.querySelectorAll('footer,.marquee,.hero-panel[data-dark],.editorial-txt,.nl-blk,.info-banner').forEach(el=>{
    if(!el.hasAttribute('data-dark'))el.setAttribute('data-dark','');
  });
}

// REVEAL
function observeReveal(){
  const obs=new IntersectionObserver(entries=>{
    entries.forEach(e=>{if(e.isIntersecting){e.target.classList.add('vis');obs.unobserve(e.target)}});
  },{threshold:.07});
  document.querySelectorAll('.reveal:not(.vis)').forEach(el=>obs.observe(el));
}



// ═══ INIT ═══
document.addEventListener('DOMContentLoaded', function() {
  // Cursor
  var cur = document.getElementById('cur');
  var mx = 0, my = 0;
  if (cur) {
    document.addEventListener('mousemove', function(e) {
      mx = e.clientX; my = e.clientY;
      cur.style.left = e.clientX + 'px';
      cur.style.top = e.clientY + 'px';
      cur.classList.toggle('inv', !!e.target.closest('[data-dark]'));
    });
    document.querySelectorAll('a,button,.prod-card,.sw,.story-card,.art-cta-card,.pd-learn,.pack-opt,.nav-bag-wrap,.pack-tile').forEach(function(el) {
      el.addEventListener('mouseenter', function() { cur.classList.add('big'); });
      el.addEventListener('mouseleave', function() { cur.classList.remove('big'); });
    });
  }

  // Nav scroll
  var nav = document.getElementById('nav');
  window.addEventListener('scroll', function() {
    if (nav) nav.classList.toggle('sc', window.scrollY > 10);
  });

  // Pages with dark hero — white text, keep logo black on products, white on studio
  var path = window.location.pathname;
  if (path.indexOf('/products/') !== -1) {
    document.body.classList.add('nav-on-dark');
    document.body.classList.add('nav-keep-logo');
  } else if (path.indexOf('/pages/studio') !== -1) {
    document.body.classList.add('nav-on-dark');
  }

  // Tag dark sections
  tagDark();
  updBag();

  // Reveal on scroll
  observeReveal();

  // Marquee
  var t = document.querySelector('.mq-t');
  if (t) {
    var w = t.scrollWidth / 2;
    var pos = 0;
    (function tick() {
      pos -= 0.5;
      if (Math.abs(pos) >= w) pos = 0;
      t.style.transform = 'translateX(' + pos + 'px)';
      requestAnimationFrame(tick);
    })();
  }

  // Build carousel on homepage
  if (document.getElementById('carTrack')) buildCar();

  // Shop page
  if (document.getElementById('shopGrid')) renderShop('all');

  // Product page init
  var path = window.location.pathname;
  if (path.indexOf('/products/') !== -1) {
    var handle = path.split('/products/')[1].split('?')[0].split('/')[0];
    var hmap = {'bee-mug':'mug30','bee-espresso':'espresso','frontier-tray':'tray'};
    var pid = hmap[handle];
    if (pid) {
      // Check for pack parameter in URL
      var urlParams = new URLSearchParams(window.location.search);
      var packParam = parseInt(urlParams.get('pack')) || 0;
      openProduct_shopify(pid, packParam);
      checkStock();
    }
  }
});

function openProduct_shopify(id, packIdx) {
  if (!PRODS[id]) return;
  curProd = id; selPack = packIdx || 0; singleCol = 'Olive'; cupCols = {};
  var p = PRODS[id];
  var set = function(elId, val) { var el=document.getElementById(elId); if(el) el.textContent=val; };
  var setH = function(elId, val) { var el=document.getElementById(elId); if(el) el.innerHTML=val; };
  set('pdCat', p.cat||'');
  set('pdName', p.name);
  set('pdSubName', p.subName);
  setH('pdDesignAcc', (p.details?'<p style="margin-bottom:12px">'+p.details+'</p>':'')+'<p style="color:var(--grey)">'+(p.designer||'Francisco Pereira')+', '+p.year+'.</p>');
  setH('pdInfoAcc', p.info||'');
  updatePdPrice();

  // Colour selector - hide if selected pack has multiple cups
  var sc = document.getElementById('pdSingleCol');
  var selectedPk = p.packs[selPack] || p.packs[0];
  if (sc) sc.style.display = (p.hasColor && selectedPk.cups <= 1) ? '' : 'none';

  // Packs
  var pw = document.getElementById('pdPackWrap');
  if (pw) {
    if (p.packs.length > 1) { pw.style.display=''; renderPackOpts(p); }
    else pw.style.display = 'none';
  }

  // Upsell
  var uh = document.getElementById('upsell');
  if (uh) {
    if (p.upsell && selPack===0) {
      uh.style.display='block';
      uh.innerHTML = p.upsell + ' <a onclick="openProduct(\''+p.upsellId+'\')">See the set</a>';
    } else uh.style.display='none';
  }

  // Gallery
  var photosEl = document.getElementById('pdPhotos');
  if (photosEl && p.photos) {
    var html = '';
    p.photos.forEach(function(ph) {
      var src = ph.src || '';
      if (ph.type==='dynamic' && p.colPhotos && p.colPhotos['Olive']) src = p.colPhotos['Olive'];
      if (src) html += '<div class="pd-gallery-img"' + (ph.type==='dynamic'?' id="pdDynImg"':'') + '>'
        + '<img src="'+src+'" alt="'+p.name+'" style="position:absolute;inset:0;width:100%;height:100%;object-fit:cover"></div>';
    });
    html += '<div class="pd-gallery-text"></div><div class="pd-photos-foot"></div>';
    photosEl.innerHTML = html;

    // If a pack is pre-selected, update the first image immediately
    if (selPack > 0 && p.packPhotos) {
      var pk = p.packs[selPack];
      var psrc = pk && p.packPhotos[pk.label];
      if (psrc) {
        var dynImg = document.getElementById('pdDynImg');
        if (dynImg) {
          var mi = dynImg.querySelector('img');
          if (mi) mi.src = psrc;
        }
      }
    }
  }

  // Learn more card
  var lmEl = document.getElementById('pdLearnMore');
  if (lmEl && p.learnMore) {
    var lm = p.learnMore;
    var sm = {bee:'journal-bee-collection',frontier:'journal-frontier',campaign:'journal-the-film',identity:'journal-identity',akira:'journal-akira2000'};
    var su = '/pages/' + (sm[lm.story]||lm.story);
    lmEl.innerHTML = '<div class="pd-learn" onclick="location.href=\''+su+'\'">'
      + '<div class="pd-learn-img"><img src="'+lm.img+'" alt="" style="position:absolute;inset:0;width:100%;height:100%;object-fit:cover"></div>'
      + '<div class="pd-learn-body"><div class="pd-learn-label">Journal</div>'
      + '<div class="pd-learn-title">'+lm.title+'</div>'
      + '<div class="pd-learn-text">'+lm.text+'</div>'
      + '<div class="pd-learn-cta">Read more →</div></div></div>';
  }
}


/* SEIS - SHOPIFY FORMS POPUP ANIMATION */

(function () {
  const initialized = new WeakSet();

  function setupPopup(host) {
    const root = host.shadowRoot;
    if (!root || initialized.has(root)) return;

    initialized.add(root);

    let previousDialog = null;
    let wasVisible = false;

    function checkPopup() {
      const dialog = root.querySelector(
        'section[role="dialog"][data-sizing="form-wrapper"]'
      );

      const visible = !!dialog &&
        dialog.getBoundingClientRect().width > 0 &&
        dialog.getBoundingClientRect().height > 0 &&
        getComputedStyle(dialog).visibility !== 'hidden' &&
        getComputedStyle(dialog).opacity !== '0' &&
        getComputedStyle(host).display !== 'none';

      if (dialog !== previousDialog) {
        previousDialog = dialog;
        wasVisible = false;
      }

      if (visible && !wasVisible) {
        dialog.animate([
          {
            opacity: 0,
            transform: 'scale(0.35) translateY(50px)'
          },
          {
            opacity: 1,
            transform: 'scale(1.06) translateY(-6px)',
            offset: 0.7
          },
          {
            opacity: 1,
            transform: 'scale(1) translateY(0)'
          }
        ], {
          duration: 900,
          easing: 'cubic-bezier(0.22, 1, 0.36, 1)'
        });
      }

      wasVisible = visible;
    }

    const observer = new MutationObserver(checkPopup);

    observer.observe(root, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: [
        'class', 'style', 'hidden', 'aria-hidden'
      ]
    });

    observer.observe(host, {
      attributes: true,
      attributeFilter: ['class', 'style', 'hidden']
    });

    checkPopup();
  }

  function findForms() {
    document.querySelectorAll(
      'shopify-forms-embed'
    ).forEach(setupPopup);
  }

  const pageObserver = new MutationObserver(findForms);

  pageObserver.observe(document.documentElement, {
    childList: true,
    subtree: true
  });

  findForms();

  window.addEventListener('load', findForms);
})();


/* SEIS - SMALLER NEWSLETTER SIDE TAB */

(function () {
  const styled = new WeakSet();

  function resizeTeaser() {
    document.querySelectorAll('shopify-forms-embed').forEach(host => {
      const root = host.shadowRoot;
      if (!root || styled.has(root)) return;

      styled.add(root);

      const style = document.createElement('style');
      style.textContent = `
        [data-testid="form-teaser"] {
          padding: 14px 15px !important;
          border-radius: 8px !important;
        }
          [data-testid="form-teaser"] h3 {
  font-family: 'Overused Grotesk', sans-serif !important;
  font-size: 12px !important;
  font-weight: 600 !important;
  font-stretch: normal !important;
  letter-spacing: 0.8px !important;
  line-height: 0.8 !important;
  white-space: nowrap !important;
}

      `;

      root.appendChild(style);
    });
  }

  const observer = new MutationObserver(resizeTeaser);

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true
  });

  resizeTeaser();
})();



/* SEIS - SHOPIFY FORMS POPUP STYLE */

(function () {
  const styled = new WeakSet();

  function stylePopup() {
    document.querySelectorAll('shopify-forms-embed').forEach(host => {
      const root = host.shadowRoot;
      if (!root || styled.has(root)) return;

      styled.add(root);

      const style = document.createElement('style');

      style.textContent = `
        /* SEIS FONT */

        section[role="dialog"][data-sizing="form-wrapper"] {
          font-family: 'Overused Grotesk', sans-serif !important;

        }

        section[role="dialog"][data-sizing="form-wrapper"] h2 {
          font-family: 'Overused Grotesk', sans-serif !important;
          font-weight: 600 !important;
        }

        section[role="dialog"][data-sizing="form-wrapper"] p,
        section[role="dialog"][data-sizing="form-wrapper"] input,
        section[role="dialog"][data-sizing="form-wrapper"] button {
          font-family: 'Overused Grotesk', sans-serif !important;
          font-weight: 300 !important;
        }
          

      `;

      root.appendChild(style);
    });
  }

  const observer = new MutationObserver(stylePopup);

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true
  });

  stylePopup();
})();
